import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    isVisible: false,
    response: {}
  },
  getters: {
    isVisible: state => state.isVisible,
    response: state => state.response
  },
  mutations: {
    toggleModal (state) {
      state.isVisible = !state.isVisible
    },
    setResponse (state, payload) {
      state.response = payload
    }
  },
  actions: {
    async createAgreementItemsForCollection ({ commit, state }, params) {
      const response = await new ApiService(
        `e_x_a_b_agreements/create_agreement_items_multi`
      ).post(params.body)
      commit('setResponse', response)
    }
  }
}
